// Client-side view of "is there a session?", read from the non-HttpOnly
// breadcrumb cookie the server mints alongside the real (HttpOnly, secret)
// session cookie in /auth/callback. The breadcrumb carries no secret — only a
// boolean — so reading it in JS is safe. It exists purely so the SPA can decide
// landing-vs-app SYNCHRONOUSLY before the router mounts, avoiding a flash of
// the wrong content (FOUC). The HttpOnly cookie remains authoritative on the
// server; this is never trusted for authorization.

const PRESENCE_COOKIE = "joesgrove_session_present";

// isLoggedIn reports whether the session-presence breadcrumb is set. Read it at
// render time — login/logout are full-page navigations, so the value is always
// re-evaluated against fresh cookies after a reload.
export function isLoggedIn(): boolean {
  if (typeof document === "undefined") return false;
  return document.cookie
    .split("; ")
    .some((c) => c === `${PRESENCE_COOKIE}=1`);
}

// clearSessionBreadcrumb deletes the breadcrumb client-side. Called when the
// API reports 401 so an expired session falls back to the landing page on the
// next render instead of looping on a stale "logged in" view. The real cookie
// is HttpOnly and cleared server-side on logout / expiry.
export function clearSessionBreadcrumb(): void {
  if (typeof document === "undefined") return;
  document.cookie = `${PRESENCE_COOKIE}=; Max-Age=0; Path=/; SameSite=Lax`;
}
